import CityPageTemplate from "../city-template/CityPageTemplate";
import { londonderryConfig } from "./data";

export default function LondonderryPage() {
  return <CityPageTemplate config={londonderryConfig} />;
}